import styled from "@emotion/styled"
import Typography from '@material-ui/core/Typography';
import colorPalette from '~/theme/colorPalette.js';

const CatalogCodeLabel = ({quantity, code}) => {
  // ７商品以上組み合わせてご注文可能な商品かどうか
  const labelColor = quantity == 7 ? `${colorPalette.quantity_terms.setOnly}` : `${colorPalette.quantity_terms.single}`;

  return (
    <StyledLabel color={labelColor} >
      {code}
    </StyledLabel>
  )
}

export default CatalogCodeLabel;

const StyledLabel = styled(Typography)`
  background-color: ${props => props.color};
  color: white;
  padding: 0 10px 0 5px;
  border-radius: 2px 10px 10px 2px;
`;
